// extracted by mini-css-extract-plugin
export default {"screen":"MessageModal_screen__cHl99","messageBox":"MessageModal_messageBox__nLPfp"};